module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/check-cb0cc38d483bd0cae71c783d60b3d9f1.svg";